import { TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import FieldFormControl from '../FieldFormControl';

const ContactPhoneField = ({ field, index, disabled }) => {
	const { getFieldProps, values, setFieldValue, getFieldHelpers, getFieldMeta } =
		useFormikContext();

	const { onBlur: onFieldBlur, onChange, ...fieldProps } = getFieldProps(field.name);

	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	const [name, setName] = useState(values.contacts?.[index]?.[field.fieldName] ?? '');

	useEffect(() => {
		console.log('Current contact', values.contacts?.[index]);
		setName(values.contacts?.[index]?.[field.fieldName] ?? '');
	}, [values.contacts?.[index], values.contacts?.[index]?.[field.fieldName]]);

	return (
		<FieldFormControl {...{ disabled, field, error, errorMessage, currentValue: name }}>
			<NumericFormat
				customInput={TextField}
				decimalScale={0}
				fixedDecimalScale
				allowNegative={false}
				allowLeadingZeros
				{...fieldProps}
				onValueChange={({ value }) => setName(value)}
				onBlur={async (e) => {
					setFieldValue(field.name, name);
					setTimeout(() => {
						onBlur(e);
					}, 100);
				}}
				value={name}
				{...{ error, disabled }}
			/>
		</FieldFormControl>
	);
};

export default ContactPhoneField;
